import { render } from "./GetZXZZPage.vue?vue&type=template&id=6ed7607a&scoped=true"
import script from "./GetZXZZPage.vue?vue&type=script&lang=js"
export * from "./GetZXZZPage.vue?vue&type=script&lang=js"

import "./GetZXZZPage.vue?vue&type=style&index=0&id=6ed7607a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed7607a"]])

export default __exports__